import React from 'react';

import { useGetOfferingEntitlementsQuery } from '../check-entitlements/useGetOfferingEntitlementsQuery';

type Props = {
  offeringId: string;
};

type AccessCheckResult = {
  loading: boolean;
  canManage: boolean;
};

/**
 * Checks accessibility of an Institutional Manage Passive OB.
 */
export function useCheckInstitutionalPassiveOrderBookAccess({
  offeringId,
}: Props): AccessCheckResult {
  const { data: entitlements, loading } = useGetOfferingEntitlementsQuery({ offeringId });

  const accessChecks = React.useMemo(
    () => ({
      canManage: entitlements.includes('MANAGE:PASSIVE_ORDER_BOOK'),
    }),
    [entitlements]
  );

  return { loading, ...accessChecks };
}

export default useCheckInstitutionalPassiveOrderBookAccess;
